import { useEffect } from "react";
import Header from "../../components/GenericHeader/Header";
import Menu from "../../components/Menu/Menu";
import NotificationDetail from "../../components/Notification/NotificationDetail";
import useTrackPageView from "../../utils/useTrackPageView";
import MenuProfile from "../../components/Menu/MenuProfile";
import CommunicationDetail from "../../components/Communication/CommunicationDetail";

const Communication = () => {
    const trackPageView = useTrackPageView("Notificaciones");

    useEffect(() => {
        trackPageView();
    },[]);

    return (
        <>
            <MenuProfile />
            <Header title='Comunicaciones' />
            <CommunicationDetail />
        </>
    );
};

export default Communication;